import { render, staticRenderFns } from "./OrdersViewInfoCards.vue?vue&type=template&id=61eeb036"
import script from "./OrdersViewInfoCards.vue?vue&type=script&lang=js"
export * from "./OrdersViewInfoCards.vue?vue&type=script&lang=js"
import style0 from "./OrdersViewInfoCards.vue?vue&type=style&index=0&id=61eeb036&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports